var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_6910)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1663 17.9346H1.84212C1.33428 17.9346 0.922119 18.3472 0.922119 18.8569V45.0773C0.922119 45.587 1.33428 46.0001 1.84212 46.0001H44.1663C44.2873 46 44.4071 45.976 44.5189 45.9296C44.6307 45.8831 44.7322 45.8151 44.8177 45.7294C44.9031 45.6437 44.9709 45.542 45.0171 45.4301C45.0632 45.3182 45.0869 45.1984 45.0867 45.0773V18.8569C45.0868 18.7359 45.0631 18.616 45.0169 18.5042C44.9707 18.3924 44.903 18.2907 44.8175 18.2051C44.732 18.1194 44.6305 18.0515 44.5188 18.0051C44.407 17.9586 44.2873 17.9347 44.1663 17.9346Z",
    fill: "#D35400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30005 7.34814V45.07C2.30005 45.5838 2.71221 46.0001 3.22005 46.0001H42.7805C42.9019 45.9994 43.022 45.9749 43.134 45.9278C43.2459 45.8807 43.3474 45.812 43.4328 45.7257C43.5182 45.6394 43.5858 45.5371 43.6316 45.4247C43.6775 45.3122 43.7007 45.1919 43.7 45.0704V0.9155C43.7007 0.794079 43.6775 0.673716 43.6316 0.561284C43.5858 0.448851 43.5182 0.34655 43.4328 0.260223C43.3474 0.173896 43.2459 0.105232 43.134 0.0581535C43.022 0.0110747 42.9019 -0.0134975 42.7805 -0.0141602L9.66189 -0.0104802L2.30005 7.34814Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.3999 33.1202L43.6985 17.9402L43.6999 21.151L23.4728 33.1202H18.3999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.919678 45.0757C0.919678 45.5863 1.33138 45.9998 1.83968 45.9998H44.1597C44.6675 45.9998 45.0797 45.5863 45.0797 45.0757V19.3198L22.9997 32.6598L0.919678 19.3198V45.0757Z",
    fill: "#F39C12"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30005 7.34804L9.66051 7.35264V0L2.30005 7.34804Z",
    fill: "#F1C40F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.919678 19.3198L0.943598 44.1598L22.9997 32.6598L0.919678 19.3198Z",
    fill: "#F1C40F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.08 19.3198L23 32.6598L45.08 44.1598V19.3198Z",
    fill: "#E57E22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0797 45.076V44.1602L22.9997 32.6602L44.7706 45.7619C44.9587 45.5931 45.0797 45.3497 45.0797 45.076ZM0.919678 45.076V44.1602L22.9997 32.6602L1.2288 45.7619C1.13181 45.6758 1.05412 45.5702 1.00085 45.452C0.947572 45.3338 0.919909 45.2057 0.919678 45.076Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_6910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.97eb95d817b9308f618144ec0daa4ba9.svg";
export { ForwardRef as ReactComponent };